// 學習紀錄流程群（批次 15 Wave 2，B7-2，Gitea issue #13）：
// training-study-record-study-record-fill（學習紀錄填寫）／training-study-record-study-record-status
// （學習紀錄查詢）的行為元件。掛在 PageBehavior（cellOverride/bulkActions/tableArea/rowExpanded/
// selectionBuckets）。
//
// legacy 對應（行號以單檔 grep -n 重驗 2026-09-25，基準＝ePortfolio_work/.../views/training/studyRecord/；
// 詳批次 15 執行文件 §1.2）：
//   - fill 頁（studyRecordFill.jsp）：`一次填寫多類`鈕（fill-UPDATE，:268-270）→fillCross(:27)＋
//     說明 `需選擇學習目標後方數字相同的項目`(:269)；`查詢暫存或待填`鈕（:285-288）→doQueryDraft(:161-190)＋
//     #fillDraftTable（樣板 :304-318：`單號：{id} - {createDate}建立`(:309)→showFill／`刪除`(:194/:315)→
//     deleteStudyRecordForm confirm `是否確定要刪除?`／`(紀錄被退回)`；空→`無暫存或待填資料!`(:288)）。
//   - 主表 9 欄（:46-108）：填寫選擇（:49-56；isCrossTargetFill==1 跨填→checkbox tgCheckBox value=
//     studyTargetId(:54)；否則 `填寫`鈕(:56)→fillOne(:99)）/已填明細（details-control(:59)→
//     getStudyTargetFormList(:119)）/訓練階段 genPhaseName(:63)/學習目標 `{name} ({formTemplateId})`(:65-66)/
//     目標數量（必修 N／N 選 M :68-78）/完成數（a.showToDone(:82)→showStatus(:103)）/填寫中簽核中(:84)/
//     開始日/應完成日。
//   - fillChoiceModal.jsp（選擇學習項目）：title `{學習紀錄填寫}-設定簽核流程及選擇學習項目`(:183)；
//     `1. 設定簽核流程`(:186)（formFlowListTable(:188)＝templateForFiller）＋`2. 選擇學習項目`(:191)
//     （學習目標分組 bg-success＋項目列 ccCheckBox(:134/:221/:231)＋應完成數/已填寫數/未填寫數(:199-201)）；
//     footer 關閉/`3. 下一步`(:212)。fillCross(:27-58)：0 筆→`沒有選擇資料!`(:46)；formTemplateId>1 種→
//     `學習目標的表單不同，不可同時選擇!`(:51)；fillOne(:10-24)：fillType=='share'→Multi(checkbox :219)：
//     Single(radio :229)。nextGenForm(:108-166)：未勾→`沒有選擇學習項目!`(:141)→genRecordForm(:157)→
//     #formContentModal＋initFill＋info `學習紀錄已經產生，請繼續填寫內容!`(:163)。
//   - studyRecordFormModal.jsp（填寫學習紀錄內容 #formContentModal modal-xxl :313-330，title :326）：
//     內容＝server html（genRecordForm/showStudyRecordForm :71）；showFill(:57-74)；fillForm(:195-247)：
//     submit&&nextFlowId>0&&下一填寫者空(:217-221)→`請輸入下一流程填寫人員再提交！`；confirm
//     `是否確定要{actionDesc}?`(:243)→fillFormAjax(:247)→info(infoMessage)＋fillDone→hide＋callback；
//     deleteStudyRecordForm(:296-309) confirm `是否確定要刪除?`(:297)。
//   - recordFormTemplate.jsp（已填明細展開 :68-91）：表 全選(selectAll :72)/紀錄建立時間(:73)/學習項目(:74)/
//     簽核流程(:75)；列 checkbox formId（form.done||currentFlow.flowRole==='Student'→remove :47-49)＋
//     `單號: {id}<br>{createDate}`(:85)→showFill(:84)＋recordData（ul li；同 target→bold）＋flowString
//     （genFlowList：未完成★ text-danger／`待指定({role})`／`{name}({role})`／added→`加會`）。
//   - targetDetailStatus.jsp（學習項目完成狀態 :63-77）：info 必修 N(:36)／N 選 M；表 學習項目/應完成
//     （caseType==1→caseQty 否則 `選修`(:13)）/已完成 簽核完成/填寫中 簽核中（>0→text-danger）；
//     showStatus(:31-46)→getStudyTargetDetailStatusListAjax(:44)。
//   - status 頁（studyRecordStatus.jsp）：主表 10 欄（:60-123；比 fill 多 訓練計畫(:66)/學員(:72)）；展開(:128-136)→
//     isPermitUpdate→`變更填寫者` btn-danger（changeFillerBtn :130）＋表 selectAll(:140-143)；changeFillerBtn→
//     modal（saveNewFillerBtn(:151) 批次模式）；a.changerFlowFiller(:187)→modal（flow 模式 saveNewFlowFillerBtn :176）；
//     批次存檔(:155-188)：formIds 0→`請選擇要變更的紀錄!`(:161)／新填寫者空→`請選擇填寫者!`(:165/:179)→confirm
//     `是否確定要變更?`(:200/:224)→changeFillerAjax(:202)/changeFlowFillerAjax(:226)→hide＋doQuery＋info；
//     查詢表單加 學員(:335)＋完成狀態(:349)（ALL 全部/DONE 己完成(:351)/NOT 未完成）。
//   - 0 契約參數頁（verify／form-content×2／show-study-record）維持原狀（KNOWN-NOT-DONE）。
//
// 雛形簡化（全部【雛形值待實機校準】）：
//   - 暫存/待填清單＝種子（getTodoStudyRecordListAjax）；刪除暫存＝local state（無真後端，
//     0 data-effect 誠實標註）。
//   - 填寫學習紀錄內容＝結構鏡像（server 動態表單 0 契約，內容 placeholder；CKEDITOR/
//     datetimepicker 不鏡像）→ KNOWN-NOT-DONE。
//   - 退回/加會（fillReason $.confirm 輸入框）不鏡像 → KNOWN-NOT-DONE；雛形按鈕列＝關閉/暫存/提交。
//   - 變更填寫者寫入＝列上 studyRecordForms 的 flowList accountId 更新（update op，C5-j）。
//
// 【證據等級】§7 第 3 級（原始碼）。

import { useState, type ReactElement } from 'react';
import { Button } from '@/components/base/Button';
import { Checkbox } from '@/components/base/Checkbox';
import { Select } from '@/components/base/Select';
import { TextInput } from '@/components/base/TextInput';
import { ModalFrame, useDialogs } from '@/components/layouts';
import { LINK_TEXT_CLASS } from '@/components/base/shared-classes';
import { t } from '@/messages/zh-TW';
import { useDataSource } from '@/mocks';
import type { Row } from '@/mocks/types';
import type { BehaviorFlowContext } from '../templates/page-behaviors';
import {
  TRAINING_FORM_FLOW_SEED,
  TRAINING_MENTOR_OPTIONS,
  TRAINING_STUDENT_OPTIONS,
  TRAINING_STUDY_RECORD_DRAFT_SEED,
} from '@/mocks/resource-rules';
import { FormFlowListTable } from './PlanInstDetail';

// ---------------------------------------------------------------------------
// 共用小元件
// ---------------------------------------------------------------------------

/** 目標數量（caseType==1→`必修 {caseQty}`；否則 `{sumCaseQty} 選 {caseQty}`；fill :67-78）。 */
export function targetQtyOf(row: Row): string {
  if (String(row['caseType'] ?? '') === '1') {
    return `必修 ${String(row['caseQty'] ?? '')}`;
  }
  return `${String(row['sumCaseQty'] ?? '')} 選 ${String(row['caseQty'] ?? '')}`;
}

/** 學習目標欄（`{studyTargetName} ({formTemplateId})`；fill :63-66）。 */
export function targetLabelOf(row: Row): string {
  return `${String(row['studyTargetName'] ?? '')} (${String(row['formTemplateId'] ?? '')})`;
}

/** genFlowList（fill :209-236／status :297-330）：★未完成／待指定／名稱(角色)／加會。 */
function FlowString({
  flowList,
  isPermitUpdate,
  formDone,
  onChangerFlowFiller,
  uiIdPrefix,
}: {
  flowList: Row[];
  isPermitUpdate: boolean;
  formDone: boolean;
  onChangerFlowFiller?: (flowId: string, formId: string) => void;
  uiIdPrefix: string;
}): ReactElement {
  const parts: ReactElement[] = [];
  let meetNotDone = false;
  flowList.forEach((flow, index) => {
    if (index > 0) {
      parts.push(<span key={`arrow-${index}`}>{'→'}</span>);
    }
    const flowRole = String(flow['flowRole'] ?? '');
    const added = flow['added'] === true;
    const roleName = added ? '加會' : String(flow['flowRoleName'] ?? '');
    const accountName = String(flow['accountName'] ?? '');
    const notDone = flow['done'] !== true;
    const star = notDone && !meetNotDone;
    if (notDone && !meetNotDone) {
      meetNotDone = true;
    }
    const isStudent = flowRole === 'Student';
    const clickable = isPermitUpdate && !formDone && !isStudent;
    const text = accountName === '' ? `待指定(${roleName})` : `${accountName}(${roleName})`;
    parts.push(
      <span
        key={`flow-${index}`}
        data-ui-id={clickable ? `${uiIdPrefix}-flow-changer-${String(flow['id'] ?? index)}` : undefined}
        className={`${star ? 'text-red-600' : ''} ${clickable ? 'cursor-pointer underline' : ''}`.trim() || undefined}
        onClick={
          clickable
            ? () => onChangerFlowFiller?.(String(flow['id'] ?? ''), String(flow['formId'] ?? ''))
            : undefined
        }
      >
        {star ? '★' : ''}
        {text}
      </span>,
    );
  });
  return <span data-ui-id={`${uiIdPrefix}-flow`}>{parts}</span>;
}

// ---------------------------------------------------------------------------
// 暫存或待填區（fill 頁 tableArea；doQueryDraft :161-190）
// ---------------------------------------------------------------------------

/** 查詢暫存或待填（種子；刪除＝local state 0 data-effect；showFill→填寫學習紀錄內容 modal）。 */
export function StudyRecordDraftArea({
  pageId,
  children,
}: {
  pageId: string;
  children: ReactElement;
}): ReactElement {
  const dialogs = useDialogs();
  const [drafts, setDrafts] = useState<readonly Row[]>(TRAINING_STUDY_RECORD_DRAFT_SEED);
  const [showFillForm, setShowFillForm] = useState<Row | null>(null);

  /** doQueryDraft（:165-196）：重新載入種子（雛形無真後端）。 */
  const refresh = () => {
    setDrafts(TRAINING_STUDY_RECORD_DRAFT_SEED);
  };

  /** 刪除暫存（:201-204 doDeleteDraft→deleteStudyRecordForm confirm `是否確定要刪除?`）。 */
  const deleteDraft = (entry: Row) => {
    void (async () => {
      const confirmed = await dialogs.confirm('是否確定要刪除?');
      if (!confirmed) {
        return;
      }
      // 雛形無真後端：local state 移除＋0 data-effect（legacy deleteStudyRecordFormAjax）。
      setDrafts((current) =>
        current.filter((candidate) => candidate !== entry),
      );
      await dialogs.info(t('state.saveSuccess'));
    })();
  };

  return (
    <>
      <div data-ui-id={`${pageId}-draft-area`} className="mb-3">
        <Button
          uiId={`${pageId}-draft-refresh`}
          variant="default"
          size="sm"
          type="button"
          onClick={refresh}
        >
          查詢暫存或待填
        </Button>
        <table className="mt-2 w-full border-collapse text-sm" data-ui-id={`${pageId}-draft-table`}>
          <tbody>
            {drafts.map((entry, index) => {
              const reject = String(entry['rejectReason'] ?? '') !== '' ? '(紀錄被退回)' : '';
              return (
                <tr key={index} data-ui-id={`${pageId}-draft-row-${index}`}>
                  <td className="p-1">
                    <button
                      type="button"
                      data-ui-id={`${pageId}-draft-showfill-${index}`}
                      className="text-left"
                      onClick={() => setShowFillForm(entry)}
                    >
                      <span className="text-base font-bold">
                        {`單號：${String(entry['studyRecordFormId'] ?? '')} - ${String(entry['createDate'] ?? '')}建立`}
                      </span>
                    </button>
                    <Button
                      uiId={`${pageId}-draft-delete-${index}`}
                      variant="danger"
                      size="sm"
                      type="button"
                      onClick={() => deleteDraft(entry)}
                    >
                      刪除
                    </Button>
                    {reject !== '' ? <span className="text-red-600">{reject}</span> : null}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {drafts.length === 0 ? (
          <p data-ui-id={`${pageId}-draft-empty`}>無暫存或待填資料!</p>
        ) : null}
      </div>
      {children}
      <StudyRecordFormContentModal
        pageId={pageId}
        open={showFillForm !== null}
        formKey={String(showFillForm?.['formKey'] ?? '')}
        phaseTargetId={String(showFillForm?.['phaseTargetId'] ?? '')}
        studyRecordFormId={String(showFillForm?.['studyRecordFormId'] ?? '')}
        items={[]}
        flowList={[]}
        onClose={() => setShowFillForm(null)}
      />
    </>
  );
}

// ---------------------------------------------------------------------------
// 填寫學習紀錄內容 modal（#formContentModal；0 契約 server 動態表單→結構鏡像）
// ---------------------------------------------------------------------------

/** 填寫學習紀錄內容（結構鏡像：目標/項目表＋簽核流程＋下一填寫者＋關閉/暫存/提交）。 */
export function StudyRecordFormContentModal({
  pageId,
  open,
  formKey,
  phaseTargetId,
  studyRecordFormId,
  items,
  flowList,
  onClose,
}: {
  pageId: string;
  open: boolean;
  formKey: string;
  phaseTargetId: string;
  studyRecordFormId: string;
  items: readonly Row[];
  flowList: readonly Row[];
  onClose: () => void;
}): ReactElement {
  const dialogs = useDialogs();
  const [nextFillerId, setNextFillerId] = useState('');
  const actionDescOf = (action: string) => (action === 'draft' ? '暫存' : '提交');

  /** fillForm（:219-263）：submit＋nextFillerId 空→`請輸入下一流程填寫人員再提交！`→confirm→info。 */
  const fillForm = (action: 'draft' | 'submit') => {
    void (async () => {
      const actionDesc = actionDescOf(action);
      if (action === 'submit' && nextFillerId.trim() === '') {
        await dialogs.alert('請輸入下一流程填寫人員再提交！'); // :218
        return;
      }
      const confirmed = await dialogs.confirm(`是否確定要${actionDesc}?`); // :243
      if (!confirmed) {
        return;
      }
      // 雛形無真後端（fillFormAjax）：成功訊息＋關 modal（批次 9/14 匯入同款誠實標註）。
      await dialogs.info(t('state.saveSuccess'));
      onClose();
      void formKey;
      void phaseTargetId;
      void studyRecordFormId;
    })();
  };

  return (
    <ModalFrame
      uiId={`${pageId}-form-content-dialog`}
      open={open}
      title="填寫學習紀錄內容"
      size="lg"
      onClose={onClose}
      footer={
        <>
          <Button uiId={`${pageId}-form-content-cancel`} variant="default" size="sm" type="button" onClick={onClose}>
            關閉
          </Button>
          {/* isFiller→暫存（studyRecordFormContent.jsp:108）；isMainFiller→提交（:113）；退回 :110。 */}
          <Button
            uiId={`${pageId}-form-content-draft`}
            variant="default"
            size="sm"
            type="button"
            onClick={() => fillForm('draft')}
          >
            暫存
          </Button>
          <Button
            uiId={`${pageId}-form-content-submit`}
            variant="primary"
            size="sm"
            type="button"
            onClick={() => fillForm('submit')}
          >
            提交
          </Button>
        </>
      }
    >
      <div className="space-y-3">
        <table className="w-full border-collapse text-sm" data-ui-id={`${pageId}-form-content-target-table`}>
          <thead>
            <tr className="border-b border-border-strong">
              <th className="w-2/5 p-2 text-center">學習目標</th>
              <th className="p-2 text-center">學習項目</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, index) => (
              <tr key={index} className="border-b border-border">
                <td className="p-2">{String(item['studyTargetName'] ?? '')}</td>
                <td className="p-2">
                  <ul className="ml-4 list-disc">
                    <li>{String(item['studyItemName'] ?? '')}</li>
                  </ul>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <p className="text-sm">
          簽核流程：
          {flowList.length > 0 ? (
            <FlowString
              flowList={[...flowList]}
              isPermitUpdate={false}
              formDone={false}
              uiIdPrefix={`${pageId}-form-content`}
            />
          ) : (
            ''
          )}
        </p>
        {/* nextFillerDiv（studyRecordFormContent.jsp:91-92；★請輸入並確認下一流程填寫人員再提交）。 */}
        <div className="flex items-center gap-2" data-ui-id={`${pageId}-form-content-next-filler`}>
          <label className="text-sm text-red-600">
            ★請輸入並確認下一流程填寫人員再提交：
          </label>
          <div className="w-40">
            <TextInput
              uiId={`${pageId}-form-content-search-next-filler`}
              value=""
              placeholder="(請輸入姓名或員編，不可填自己)"
              onChange={() => undefined}
            />
          </div>
          <div className="w-48">
            <Select
              uiId={`${pageId}-form-content-next-filler-id`}
              value={nextFillerId}
              onChange={(next) => setNextFillerId(next)}
              options={[{ value: '', label: '' }, ...TRAINING_STUDENT_OPTIONS, ...TRAINING_MENTOR_OPTIONS]}
            />
          </div>
        </div>
      </div>
    </ModalFrame>
  );
}

// ---------------------------------------------------------------------------
// 學習項目完成狀態 modal（targetDetailStatus.jsp）
// ---------------------------------------------------------------------------

/** 學習項目完成狀態（info 必修 N／N 選 M＋表 4 欄；ingQty>0→text-danger）。 */
export function TargetDetailStatusModal({
  pageId,
  open,
  row,
  onClose,
}: {
  pageId: string;
  open: boolean;
  row: Row | null;
  onClose: () => void;
}): ReactElement {
  const details =
    row === null
      ? []
      : (Array.isArray(row['targetDetails']) ? (row['targetDetails'] as Row[]) : []);
  const info =
    row === null
      ? ''
      : String(row['caseType'] ?? '') === '1'
        ? `必修 ${String(row['caseQty'] ?? '')}`
        : `${String(row['sumCaseQty'] ?? '')} 選 ${String(row['caseQty'] ?? '')}`;
  return (
    <ModalFrame
      uiId={`${pageId}-target-detail-dialog`}
      open={open}
      title="學習項目完成狀態"
      size="lg"
      onClose={onClose}
    >
      <div className="space-y-2">
        <h5 className="font-bold" data-ui-id={`${pageId}-target-detail-info`}>
          {info}
        </h5>
        <table className="w-full border-collapse text-sm" data-ui-id={`${pageId}-target-detail-table`}>
          <thead>
            <tr className="border-b border-border-strong">
              <th className="p-2 text-left">學習項目</th>
              <th className="w-[15%] p-2 text-center">應完成</th>
              <th className="w-[15%] p-2 text-center">已完成 簽核完成</th>
              <th className="w-[15%] p-2 text-center">填寫中 簽核中</th>
            </tr>
          </thead>
          <tbody>
            {details.map((detail, index) => (
              <tr key={index} className="border-b border-border" data-ui-id={`${pageId}-target-detail-row-${index}`}>
                <td className="p-2">{String(detail['studyItemName'] ?? '')}</td>
                <td className="p-2 text-center">
                  {String(detail['caseType'] ?? '') === '1' ? String(detail['caseQty'] ?? '') : '選修'}
                </td>
                <td className="p-2 text-center">{String(detail['doneQty'] ?? '')}</td>
                <td className={`p-2 text-center ${Number(detail['ingQty'] ?? '0') > 0 ? 'text-red-600' : ''}`}>
                  {String(detail['ingQty'] ?? '')}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </ModalFrame>
  );
}

// ---------------------------------------------------------------------------
// 填寫選擇 modal（fillChoiceModal.jsp）
// ---------------------------------------------------------------------------

interface FillChoiceTarget {
  /** 學習目標名（分組表頭）。 */
  name: string;
  studyTargetId: string;
  items: readonly Row[];
}

/** 填寫選擇（title `{學習紀錄填寫}-設定簽核流程及選擇學習項目`；1. 設定簽核流程／2. 選擇學習項目）。 */
export function FillChoiceModal({
  pageId,
  open,
  targets,
  flowList,
  multi,
  onClose,
  onGenerated,
}: {
  pageId: string;
  open: boolean;
  targets: readonly FillChoiceTarget[];
  flowList: readonly Row[];
  /** fillType=='share'→checkbox 多選；否則 radio 單選（itemChoiceTemplateMulti/Single）。 */
  multi: boolean;
  onClose: () => void;
  /** 3. 下一步→genRecordForm 成功（雛形：直接開填寫學習紀錄內容 modal）。 */
  onGenerated: (selected: readonly Row[], flowList: readonly Row[]) => void;
}): ReactElement {
  const dialogs = useDialogs();
  const [checkedItems, setCheckedItems] = useState<readonly string[]>([]);

  /** nextGenForm（:112-166）：未勾→`沒有選擇學習項目!`→genRecordForm→#formContentModal＋info。 */
  const nextGenForm = () => {
    void (async () => {
      if (checkedItems.length === 0) {
        await dialogs.alert('沒有選擇學習項目!');
        return;
      }
      const selected: Row[] = [];
      for (const target of targets) {
        for (const item of target.items) {
          if (checkedItems.includes(String(item['studyItemId'] ?? ''))) {
            selected.push(item);
          }
        }
      }
      onClose();
      // legacy：modal 開啟後 200ms showInfoDialog('學習紀錄已經產生，請繼續填寫內容!')。
      await dialogs.info('學習紀錄已經產生，請繼續填寫內容!');
      onGenerated(selected, [...flowList]);
    })();
  };

  return (
    <ModalFrame
      uiId={`${pageId}-fill-choice-dialog`}
      open={open}
      title="學習紀錄填寫-設定簽核流程及選擇學習項目"
      size="lg"
      onClose={onClose}
      footer={
        <>
          <Button uiId={`${pageId}-fill-choice-cancel`} variant="default" size="sm" type="button" onClick={onClose}>
            關閉
          </Button>
          <Button
            uiId={`${pageId}-fill-choice-next`}
            variant="default"
            size="sm"
            type="button"
            onClick={nextGenForm}
          >
            3. 下一步
          </Button>
        </>
      }
    >
      <div className="space-y-3">
        <h5 className="font-bold">1. 設定簽核流程</h5>
        <FormFlowListTable uiId={`${pageId}-fill-choice-flow-table`} />
        <div className="border-border border-t pt-2" />
        <h5 className="font-bold">2. 選擇學習項目</h5>
        <table className="w-full border-collapse text-sm" data-ui-id={`${pageId}-fill-choice-table`}>
          <thead>
            <tr>
              <td colSpan={5} className="border-b border-border p-2 font-bold">
                學習目標
              </td>
            </tr>
            <tr className="border-b border-border-strong">
              <td className="w-10 p-2" />
              <td className="p-2">學習項目</td>
              <td className="w-[150px] p-2 text-center">應完成數</td>
              <td className="w-[150px] p-2 text-center">已填寫數</td>
              <td className="w-[150px] p-2 text-center">未填寫數</td>
            </tr>
          </thead>
          <tbody>
            {targets.map((target) => (
              <FillChoiceTargetGroup
                key={target.studyTargetId}
                pageId={pageId}
                target={target}
                multi={multi}
                checkedItems={checkedItems}
                onToggle={(itemId, next) => {
                  if (multi) {
                    setCheckedItems((current) =>
                      next
                        ? [...current, itemId]
                        : current.filter((candidate) => candidate !== itemId),
                    );
                  } else {
                    setCheckedItems(next ? [itemId] : []);
                  }
                }}
              />
            ))}
          </tbody>
        </table>
      </div>
    </ModalFrame>
  );
}

function FillChoiceTargetGroup({
  pageId,
  target,
  multi,
  checkedItems,
  onToggle,
}: {
  pageId: string;
  target: FillChoiceTarget;
  multi: boolean;
  checkedItems: readonly string[];
  onToggle: (itemId: string, next: boolean) => void;
}): ReactElement {
  return (
    <>
      <tr className="bg-green-100" data-ui-id={`${pageId}-fill-choice-group-${target.studyTargetId}`}>
        <td colSpan={5} className="p-2">
          {target.name}
        </td>
      </tr>
      {target.items.map((item) => {
        const itemId = String(item['studyItemId'] ?? '');
        const checked = checkedItems.includes(itemId);
        return (
          <tr key={itemId} data-ui-id={`${pageId}-fill-choice-item-${itemId}`}>
            <td className="p-2 text-center">
              {multi ? (
                <Checkbox
                  uiId={`${pageId}-fill-choice-check-${itemId}`}
                  checked={checked}
                  onChange={(next) => onToggle(itemId, next)}
                />
              ) : (
                <input
                  type="radio"
                  data-ui-id={`${pageId}-fill-choice-radio-${itemId}`}
                  name={`${pageId}-fill-choice-radio`}
                  checked={checked}
                  onChange={() => onToggle(itemId, true)}
                  className="size-4"
                />
              )}
            </td>
            <td className="p-2">{String(item['studyItemName'] ?? '')}</td>
            <td className="p-2 text-center">{String(item['caseQty'] ?? '')}</td>
            <td className="p-2 text-center">{String(item['doneQty'] ?? '')}</td>
            <td className="p-2 text-center text-red-600">{String(item['xxQty'] ?? '')}</td>
          </tr>
        );
      })}
    </>
  );
}

// ---------------------------------------------------------------------------
// 已填明細展開（recordFormTemplate.jsp；fill/status 共用）
// ---------------------------------------------------------------------------

function toFormRows(list: unknown): Row[] {
  return Array.isArray(list) ? (list as Row[]) : [];
}

/** 已填明細展開（表：全選/紀錄建立時間/學習項目/簽核流程；列＋變更填寫者鈕（status UPDATE））。 */
export function StudyRecordDetailRows({
  pageId,
  row,
  uiKey,
  ctx,
  isStatus,
}: {
  pageId: string;
  row: Row;
  uiKey: string;
  ctx: BehaviorFlowContext;
  /** status 頁：isPermitUpdate→變更填寫者鈕＋flow changer 連結（fill 頁無）。 */
  isStatus: boolean;
}): ReactElement {
  const dialogs = ctx.dialogs;
  const dataSource = useDataSource();
  const forms = toFormRows(row['studyRecordForms']);
  const [checkedFormIds, setCheckedFormIds] = useState<readonly string[]>([]);
  const [changeFiller, setChangeFiller] = useState<{ mode: 'batch' | 'flow'; formId: string; flowId: string } | null>(
    null,
  );
  // changeFiller modal 的 state（changeFillerModal.jsp：新填寫者 searchNewFillerCode+newFillerId）。
  const [changeFillerState, setChangeFillerState] = useState<{ newFillerId: string }>({ newFillerId: '' });
  const newFillerName =
    [...TRAINING_STUDENT_OPTIONS, ...TRAINING_MENTOR_OPTIONS].find(
      (option) => option.value === changeFillerState.newFillerId,
    )?.label ?? '';
  /** showFill（studyRecordFormModal.jsp:51-85）：展開列的單號連結→填寫學習紀錄內容 modal。 */
  const [showFillForm, setShowFillForm] = useState<Row | null>(null);
  const isPermitUpdate = isStatus; // admin 視角（D9）

  /** 批次變更（studyRecordStatus.jsp :163-184/:212-241）；驗證順序照 legacy（先紀錄後填寫者）。 */
  const submitChangeFiller = () => {
    void (async () => {
      if (changeFiller === null) {
        return;
      }
      if (changeFiller.mode === 'batch') {
        if (checkedFormIds.length === 0) {
          await dialogs.alert('請選擇要變更的紀錄!'); // :161
          return;
        }
        if (changeFillerState.newFillerId === '') {
          await dialogs.alert('請選擇填寫者!'); // :165
          return;
        }
      } else if (changeFillerState.newFillerId === '') {
        await dialogs.alert('請選擇填寫者!'); // :179
        return;
      }
      const confirmed = await dialogs.confirm('是否確定要變更?'); // :200/:224
      if (!confirmed) {
        return;
      }
      // changeFillerAjax/changeFlowFillerAjax→雛形：列上 studyRecordForms.flowList 更新（update op）。
      const nextForms = forms.map((form) => {
        if (changeFiller.mode === 'flow' && String(form['formId'] ?? '') !== changeFiller.formId) {
          return form;
        }
        if (changeFiller.mode === 'batch' && !checkedFormIds.includes(String(form['studyRecordFormId'] ?? ''))) {
          return form;
        }
        const flowList = toFormRows(form['flowList']).map((flow) =>
          changeFiller.mode === 'batch' || String(flow['id'] ?? '') === changeFiller.flowId
            ? { ...flow, accountId: changeFillerState.newFillerId, accountName: newFillerName }
            : flow,
        );
        return { ...form, flowList };
      });
      try {
        await dialogs.processing.wrap(
          dataSource.update(pageId, String(row.id ?? ''), { studyRecordForms: nextForms }),
        );
        setChangeFiller(null);
        ctx.reload();
        await dialogs.info(t('state.saveSuccess'));
      } catch (cause: unknown) {
        await dialogs.alert(cause instanceof Error ? cause.message : t('error.generic'));
      }
    })();
  };

  const cellClass = 'border-t border-border p-2';
  return (
    <div className="bg-surface-soft p-3" data-ui-id={`${pageId}-row-${uiKey}-detail-body`}>
      {isPermitUpdate ? (
        <Button
          uiId={`${pageId}-row-${uiKey}-change-filler-btn`}
          variant="danger"
          size="sm"
          type="button"
          onClick={() => {
            setChangeFiller({ mode: 'batch', formId: '', flowId: '' });
            setChangeFillerState({ newFillerId: '' });
          }}
        >
          變更填寫者
        </Button>
      ) : null}
      <table className="w-full border-collapse text-sm" data-ui-id={`${pageId}-row-${uiKey}-detail-table`}>
        <thead>
          <tr className="border-b border-border-strong">
            <th className="w-[20px] p-2 text-left">
              {/* recordFormTemplate.jsp:72 selectAll；status 頁非 UPDATE 才藏（studyRecordStatus.jsp:128-136）。 */}
              {isStatus && !isPermitUpdate ? null : (
                <Checkbox
                  uiId={`${pageId}-row-${uiKey}-detail-select-all`}
                  checked={forms.length > 0 && checkedFormIds.length === forms.length}
                  onChange={(next) => setCheckedFormIds(next ? forms.map((form) => String(form['studyRecordFormId'] ?? '')) : [])}
                />
              )}
              全選
            </th>
            <th className="w-[140px] p-2 text-left">紀錄建立時間</th>
            <th className="p-2 text-left">學習項目</th>
            <th className="w-1/4 p-2 text-left">簽核流程</th>
          </tr>
        </thead>
        <tbody>
          {forms.map((form, index) => {
            const formDone = form['done'] === true;
            const currentFlowRole = String(form['currentFlowRole'] ?? '');
            const removable = !formDone && currentFlowRole !== 'Student'; // :47-49 form.done||Student→remove
            const recordItems = Array.isArray(form['studyItems']) ? (form['studyItems'] as string[]) : [];
            return (
              <tr key={index} data-ui-id={`${pageId}-row-${uiKey}-detail-form-${String(form['studyRecordFormId'] ?? index)}`}>
                <td className={cellClass}>
                  {removable ? (
                    <Checkbox
                      uiId={`${pageId}-row-${uiKey}-detail-form-check-${String(form['studyRecordFormId'] ?? index)}`}
                      checked={checkedFormIds.includes(String(form['studyRecordFormId'] ?? ''))}
                      onChange={(next) =>
                        setCheckedFormIds((current) =>
                          next
                            ? [...current, String(form['studyRecordFormId'] ?? '')]
                            : current.filter((candidate) => candidate !== String(form['studyRecordFormId'] ?? '')),
                        )
                      }
                    />
                  ) : null}
                </td>
                <td className={cellClass}>
                  <button
                    type="button"
                    data-ui-id={`${pageId}-row-${uiKey}-detail-showfill-${String(form['studyRecordFormId'] ?? index)}`}
                    className={`${LINK_TEXT_CLASS} cursor-pointer text-left`}
                    onClick={() => setShowFillForm(form)}
                  >
                    {`單號: ${String(form['studyRecordFormId'] ?? '')}`}
                    <br />
                    {String(form['createDateString'] ?? '')}
                  </button>
                </td>
                <td className={cellClass}>
                  <ul className="ml-4 list-disc">
                    {recordItems.map((item, itemIndex) => (
                      <li key={itemIndex}>{item}</li>
                    ))}
                  </ul>
                </td>
                <td className={cellClass}>
                  <FlowString
                    flowList={toFormRows(form['flowList'])}
                    isPermitUpdate={isPermitUpdate}
                    formDone={formDone}
                    uiIdPrefix={`${pageId}-row-${uiKey}-detail-form-${String(form['studyRecordFormId'] ?? index)}`}
                    onChangerFlowFiller={(flowId, formId) => {
                      setChangeFiller({ mode: 'flow', formId, flowId });
                      setChangeFillerState({ newFillerId: '' });
                    }}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <ModalFrame
        uiId={`${pageId}-change-filler-dialog`}
        open={changeFiller !== null}
        title="變更填寫者"
        size="md"
        onClose={() => setChangeFiller(null)}
        footer={
          <>
            <Button uiId={`${pageId}-change-filler-cancel`} variant="default" size="sm" type="button" onClick={() => setChangeFiller(null)}>
              關閉
            </Button>
            <Button
              uiId={`${pageId}-change-filler-save`}
              variant="primary"
              size="sm"
              type="button"
              dataEffect={`update:${pageId}`}
              onClick={submitChangeFiller}
            >
              存檔
            </Button>
          </>
        }
      >
        <div className="flex items-center gap-2">
          <label className="text-sm">新填寫者：</label>
          <div className="w-40">
            <TextInput
              uiId={`${pageId}-change-filler-search`}
              value=""
              placeholder="(請輸入姓名或員編)"
              onChange={() => undefined}
            />
          </div>
          <div className="w-48">
            <Select
              uiId={`${pageId}-change-filler-new-id`}
              value={changeFillerState.newFillerId}
              onChange={(next) => setChangeFillerState({ newFillerId: next })}
              options={[{ value: '', label: '' }, ...TRAINING_STUDENT_OPTIONS, ...TRAINING_MENTOR_OPTIONS]}
            />
          </div>
        </div>
      </ModalFrame>
      <StudyRecordFormContentModal
        pageId={pageId}
        open={showFillForm !== null}
        formKey={String(showFillForm?.['formKey'] ?? '')}
        phaseTargetId={String(showFillForm?.['phaseTargetId'] ?? '')}
        studyRecordFormId={String(showFillForm?.['studyRecordFormId'] ?? '')}
        items={(Array.isArray(showFillForm?.['studyItems']) ? (showFillForm['studyItems'] as string[]) : []).map(
          (name) => ({ studyTargetName: String(row['studyTargetName'] ?? ''), studyItemName: name }),
        )}
        flowList={showFillForm === null ? [] : toFormRows(showFillForm['flowList'])}
        onClose={() => setShowFillForm(null)}
      />
    </div>
  );
}

// ---------------------------------------------------------------------------
// 儲存格與工具列（fill/status 行為掛鉤用）
// ---------------------------------------------------------------------------

/** 已填明細欄的展開控制項（details-control；fill/status 共用）。 */
export function DetailExpanderCell({
  pageId,
  row,
  uiKey,
  ctx,
}: {
  pageId: string;
  row: Row;
  uiKey: string;
  ctx: BehaviorFlowContext;
}): ReactElement {
  const rowId = String(row.id ?? '');
  const expanded = ctx.expandedRowIds?.has(rowId) === true;
  return (
    <Button
      uiId={`${pageId}-row-${uiKey}-detail-toggle`}
      variant="default"
      size="sm"
      type="button"
      onClick={() => ctx.toggleRowExpand?.(rowId)}
    >
      {expanded ? '－' : '＋'}
    </Button>
  );
}

/** 完成數欄（a.showToDone→學習項目完成狀態 modal；fill :79-84／status :81-86）。 */
export function DoneStatusOpener({
  pageId,
  row,
  uiKey,
}: {
  pageId: string;
  row: Row;
  uiKey: string;
}): ReactElement {
  const [open, setOpen] = useState(false);
  return (
    <>
      <a
        data-ui-id={`${pageId}-row-${uiKey}-show-to-done`}
        className={`${LINK_TEXT_CLASS} cursor-pointer`}
        onClick={() => setOpen(true)}
      >
        {`${String(row['doneQty'] ?? '')}/${String(row['caseQty'] ?? '')}`}
      </a>
      <TargetDetailStatusModal pageId={pageId} open={open} row={row} onClose={() => setOpen(false)} />
    </>
  );
}

/**
 * 一次填寫多類／填寫選擇的核心（fillCross :29-62／fillOne :8-27）。
 * targets 由呼叫端組好；multi＝fillType=='share'（itemChoiceTemplateMulti/Single）。
 * onGenerated（nextGenForm :112-166 成功）→ 開填寫學習紀錄內容 modal。
 */
function FillChoiceCore({
  pageId,
  targets,
  multi,
  open,
  onClose,
}: {
  pageId: string;
  targets: readonly { name: string; studyTargetId: string; items: readonly Row[] }[];
  multi: boolean;
  open: boolean;
  onClose: () => void;
}): ReactElement {
  const [generated, setGenerated] = useState<{ items: readonly Row[]; flowList: readonly Row[] } | null>(null);
  return (
    <>
      <FillChoiceModal
        pageId={pageId}
        open={open}
        targets={targets}
        flowList={TRAINING_FORM_FLOW_SEED}
        multi={multi}
        onClose={onClose}
        onGenerated={(selected, flowList) => setGenerated({ items: selected, flowList })}
      />
      <StudyRecordFormContentModal
        pageId={pageId}
        open={generated !== null}
        formKey="fill-choice"
        phaseTargetId={targets[0] === undefined ? '' : targets[0].studyTargetId}
        studyRecordFormId=""
        items={generated === null ? [] : generated.items}
        flowList={generated === null ? [] : generated.flowList}
        onClose={() => setGenerated(null)}
      />
    </>
  );
}

/** 填寫選擇（單一目標；fillType=='share'→多選：單選；fill :97-107 showEdit）。 */
export function FillChoiceCellOpener({
  pageId,
  row,
  uiKey,
}: {
  pageId: string;
  row: Row;
  uiKey: string;
}): ReactElement {
  const [open, setOpen] = useState(false);
  const items = Array.isArray(row['studyItems']) ? (row['studyItems'] as Row[]) : [];
  const multi = String(row['fillType'] ?? '') === 'share';
  return (
    <>
      <Button
        uiId={`${pageId}-row-${uiKey}-fill-btn`}
        variant="primary"
        size="sm"
        type="button"
        onClick={() => setOpen(true)}
      >
        填寫
      </Button>
      <FillChoiceCore
        pageId={pageId}
        open={open}
        multi={multi}
        targets={open ? [{ name: String(row['studyTargetName'] ?? ''), studyTargetId: String(row['studyTargetId'] ?? ''), items }] : []}
        onClose={() => setOpen(false)}
      />
    </>
  );
}

/**
 * 一次填寫多類工具列（studyRecordFill.jsp:243-247；fillCross :29-62）。
 * 驗證：0 筆→`沒有選擇資料!`；formTemplateId>1 種→`學習目標的表單不同，不可同時選擇!`。
 * 勾選狀態＝selectionBuckets ['fill']（cell 的 tgCheckBox）。
 */
export function StudyRecordFillToolbar({ ctx }: { ctx: BehaviorFlowContext }): ReactElement {
  const dialogs = ctx.dialogs;
  const pageId = ctx.pageId;
  const [open, setOpen] = useState(false);
  const [targets, setTargets] = useState<readonly { name: string; studyTargetId: string; items: readonly Row[] }[]>([]);

  const fillCross = () => {
    void (async () => {
      const ids = ctx.selection?.ids('fill') ?? [];
      const rows = ids.map((id) => ctx.rowsById?.(id)).filter((row): row is Row => row !== undefined);
      if (rows.length === 0) {
        await dialogs.alert('沒有選擇資料!'); // :46
        return;
      }
      const formTemplates = [...new Set(rows.map((row) => String(row['formTemplateId'] ?? '')))];
      if (formTemplates.length > 1) {
        await dialogs.alert('學習目標的表單不同，不可同時選擇!'); // :51
        return;
      }
      setTargets(
        rows.map((row) => ({
          name: String(row['studyTargetName'] ?? ''),
          studyTargetId: String(row['studyTargetId'] ?? ''),
          items: Array.isArray(row['studyItems']) ? (row['studyItems'] as Row[]) : [],
        })),
      );
      setOpen(true);
    })();
  };

  return (
    <span data-ui-id={`${pageId}-fill-toolbar`} className="inline-flex flex-wrap items-center gap-2">
      <Button uiId={`${pageId}-fill-cross-btn`} variant="primary" size="sm" type="button" onClick={fillCross}>
        一次填寫多類
      </Button>
      <span className="text-sm text-ink">需選擇學習目標後方數字相同的項目</span>
      <FillChoiceCore
        pageId={pageId}
        open={open}
        multi
        targets={targets}
        onClose={() => setOpen(false)}
      />
    </span>
  );
}
